module.exports = __webpack_public_path__ + "static/media/phone1.5ac51ed3.png";